import { padLeft } from "./pad-left";

export function formatDate(date: string | Date) {
  const year = new Date(date).getFullYear();
  const month = new Date(date).getMonth() + 1;
  const day = new Date(date).getDate();

  return `${padLeft(year, 4)}-${padLeft(month, 2)}-${padLeft(day, 2)}`;
}

export function formatTime(date: string | Date, withSeconds = true) {
  const hours = new Date(date).getHours();
  const minutes = new Date(date).getMinutes();
  const seconds = withSeconds
    ? `:${padLeft(new Date(date).getSeconds(), 2)}`
    : "";

  return `${padLeft(hours, 2)}:${padLeft(minutes, 2)}${seconds}`;
}

export function formatDateTime(date: string | Date, withSeconds = true) {
  return `${formatDate(date)} ${formatTime(date, withSeconds)}`;
}
